<template>
  <div class="put-shelf">
    <el-form :inline="true" :model="formInline" label-position="left" class="demo-form-inline">
      <el-form-item label="商品sku：">
        <el-input maxlength='450' v-model="formInline.shopProductSku" placeholder="请输入商品sku" @keydown.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item label="仓库：" style="display:none">
        <el-select v-model="formInline.canDelivery" placeholder="全部">
          <el-option label="仓库1" :value="''"></el-option>
          <el-option label="仓库2" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
    <WmsTable :columns="tableColumns" @pageChange="pageChangeCall" :dataSource="dataSource" :isPagination="query" >
      <template #img="{ record, text }">
        <ImgPreviewsVue :images="[text]"></ImgPreviewsVue>
      </template>
      <!-- <template #action="{ record }">
        <a @click="getDetail(record)">详情</a>
      </template> -->
    </WmsTable>
    <ShelfDetail ref="shelfDetail"></ShelfDetail>
  </div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
import ImgPreviewsVue from "@/components/ImgPreviews";
import { tableColumns } from "./table";
import { Table } from "ant-design-vue";
import ShelfDetail from "./components/shelfDetail";
import { pkgPage } from "@/apis/combination";
export default {
  title: "组合列表",
  name: "combinationPutShelf",
  components: {
    ShelfDetail,
    WmsTable,
    [Table.name]: Table,
    ImgPreviewsVue,
  },
  data() {
    return {
      tableColumns,
      formInline: {},
      dataSource: [],
      params: {},
      query: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        checkingShelvFlag: 1,
        combinationProductItemFlag: 1,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      };
      pkgPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList()
    },
    onSubmit() {
      this.query.current = 1
      this.getList();
    },
    restSubmit() {
      this.formInline = {};
      this.query = {
        pageSize: 10,
        current: 1,
        total: 0,
      };
      this.getList();
    },
    getDetail() {
      this.$refs.shelfDetail.dialogVisible = true;
    },
  },
  created() { },
};
</script>
<style lang="less" scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.put-shelf {
  padding: 0 10px;
}
</style>
